module.exports = __webpack_public_path__ + "static/media/youtube.f91758e0.svg";